import React, { PropsWithChildren, ReactNode } from 'react';

import Button from '../common/Button/Button';
import ButtonGroup from '../common/ButtonGroup/ButtonGroup';

import { TestID } from '../../testID';

import type { ConfigPanelType } from '../../types/state.types';

import '../../style/global.css';
import './EditorPanels.css';

/*
 * Editor parts with replacements on one side and config on other side.
 */
export const EditorPanels: React.FC<
  PropsWithChildren<{
    extraToolbarPanelButtons?: ReactNode;
    extraToolbarButtons?: ReactNode;
    showTemplates: boolean;
    showSchema: boolean;
    onTogglePanel: (panel: ConfigPanelType) => void;
  }>
> = ({
  children,
  extraToolbarPanelButtons,
  extraToolbarButtons,
  showTemplates,
  showSchema,
  onTogglePanel,
}) => (
  <section className="editor">
    <div className="editor__header" data-testid={TestID.EditorPanels}>
      <div className="toolbar toolbar--small">
        <span>Panels:</span>
        <ButtonGroup className="input-group">
          <Button active={showTemplates} onClick={() => onTogglePanel('templates')}>
            Templates
          </Button>
          <Button
            active={showSchema}
            onClick={() => onTogglePanel('schema')}
            data-testid={TestID.PipeSchemaButton}
          >
            Schema
          </Button>
          {extraToolbarPanelButtons}
        </ButtonGroup>
        {extraToolbarButtons}
        <Button
          className="editor__options-btn"
          onClick={() => onTogglePanel('options')}
          style={{ marginLeft: '0.5rem' }}
        >
          Editor options
        </Button>
      </div>
    </div>
    <div className="editor__work-area">{children}</div>
  </section>
);
